const queryString = require("query-string");

const urlQuery = {
  getLocation() {
    return window.location;
  },
  getQuery() {
    return queryString.parse(window.location.search);
  },
  push(params, navigate) {
    if (!navigate) {
      console.error('urlQuery.push requires a navigate function from useNavigate hook');
      return;
    }
    let query = this.getQuery();
    query = { ...query, ...params }
    navigate(`${window.location.pathname}?${queryString.stringify(query)}`)
  },
  getByKey(key) {
    let query = this.getQuery();
    if (Object.hasOwnProperty.bind(query)(key)) {
      try {
        return JSON.parse(query[key]);  
      }
      catch {
        return query[key];
      }
    }
    else {
      return null;
    }
  },
  getByKeyByQuery(key, query) {
    const parsedQuery = queryString.parse(query);
    if (Object.hasOwnProperty.bind(parsedQuery)(key)) {
      try {
        return JSON.parse(parsedQuery[key]);  
      }
      catch {
        return parsedQuery[key];
      }
    }
    else {
      return null;
    }
  }
}

export default urlQuery;